module.exports = __webpack_public_path__ + "static/media/tmn-mini-logo.253d2a63.webp";